/*! @pentacode/ui v0.1.0 */
import { t as e } from "./styledElement-Dm1irIE2.js";
import { t } from "./decorateMetadata-BhwOl-pv.js";
import { t as n } from "./decorate-DHgd5sZx.js";
import { t as r } from "./css-build-DICbZE45.js";
import { LitElement as i, html as a } from "lit";
import { customElement as o, property as s, query as c, state as l } from "lit/decorators.js";
//#endregion
//#region \0lit-plugin:css-sheet:./src/elements/collapse/collapse.css.js
var u = r(":host{display:block;overflow:hidden}:host([collapsed]){height:0}"), d = class extends e(i) {
	constructor(...e) {
		super(...e), this.styles = u, this.collapsed = !1, this.collapsedHeight = 0, this._contentHeight = 0, this._resizeObserver = new ResizeObserver(() => {
			this.collapsed && this.collapsedHeight > 0 && (this._contentHeight = this._content.offsetHeight);
		});
	}
	connectedCallback() {
		super.connectedCallback(), this._content && this._resizeObserver.observe(this._content);
	}
	disconnectedCallback() {
		super.disconnectedCallback(), this._resizeObserver.disconnect();
	}
	firstUpdated() {
		this._resizeObserver.observe(this._content);
	}
	willUpdate(e) {
		(e.has("collapsed") || e.has("collapsedHeight")) && this.collapsed && this.collapsedHeight > 0 && this._content && (this._contentHeight = this._content.offsetHeight);
	}
	updated() {
		this.style.height = this.collapsed ? `${Math.min(this.collapsedHeight, this._contentHeight)}px` : "";
	}
	render() {
		return a`
            <div part="content">
                <slot></slot>
            </div>
        `;
	}
};
n([s({
	type: Boolean,
	reflect: !0
}), t("design:type", Object)], d.prototype, "collapsed", void 0), n([s({
	type: Number,
	attribute: "collapsed-height"
}), t("design:type", Object)], d.prototype, "collapsedHeight", void 0), n([l(), t("design:type", Object)], d.prototype, "_contentHeight", void 0), n([c("[part=\"content\"]"), t("design:type", typeof HTMLDivElement > "u" ? Object : HTMLDivElement)], d.prototype, "_content", void 0), d = n([o("ptc-ui-collapse")], d);
var f = d;
//#endregion
export { f as n, d as t };

//# sourceMappingURL=collapse-CzsAkLnU.js.map